<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">Industry Details</h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>Industry Name</td>
                  <td>
                    {{ industryModel.name ? industryModel.name : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Industry Id</td>
                  <td>
                    {{ industryModel.id ? industryModel.id : "" }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn
              v-if="$route.params.id == 0"
              color="primary"
              large
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Create a New Industry</v-btn
            >
            <v-btn
              v-else
              large
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Edit</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Industry } from "@/models/Industry";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      industryModel: new Industry(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "Industries",
          disabled: false,
          href: "/admin/industries",
        },
        {
          text: "Industry Details",
          disabled: false,
          href: `/admin/industries/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    industry: {
      query: gql`
        query Industry($id: ID!) {
          industry(id: $id) {
            id
            name
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
          createdBy: self.me.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.industryModel.id = this.industry.id;
        this.industryModel.name = this.industry.name;
        this.industryModel.createdBy = this.industry.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
